import React from "react";
import { tableContainer, tableBase, tableHead, tableHeader, tableCell, tableRow } from '../../../utils/tableStyle';
import EmptyState from '../../CommonComponents/EmptyState';
import { Package } from 'lucide-react';

export default function PreReleaseTable({ data, loading, actionLoading, onApprove, onReject, onViewDetails }) {
    return (
        <div className={tableContainer + ' overflow-x-auto'}>
            <table className={tableBase + ' min-w-[800px] text-xs'}>
                <thead className={tableHead} style={{ background: 'var(--color-primary)' }}>
                    <tr>
                        <th className={tableHeader + ' text-center'}>Date</th>
                        <th className={tableHeader + ' text-center'}>Time</th>
                        <th className={tableHeader + ' text-center'}>Status</th>
                        <th className={tableHeader + ' text-center'}>Branch</th>
                        <th className={tableHeader + ' text-center'}>Remarks</th>
                        <th className={tableHeader + ' text-center'}>Requested by</th>
                        <th className={tableHeader + ' text-center'}>Details</th>
                        <th className={tableHeader + ' text-center'}>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {loading ? (
                        <tr><td colSpan={8} className={tableCell + ' text-center py-10'}>Loading...</td></tr>
                    ) : data.length === 0 ? (
                        <tr>
                            <td colSpan={8} className={tableCell + ' text-center py-10'}>
                                <EmptyState icon={Package} message="No pre-release data to display yet." size="default" />
                            </td>
                        </tr>
                    ) : (
                        data.map(pr => {
                            const dt = new Date(pr.createdAt);
                            const date = dt.toLocaleDateString();
                            const time = dt.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
                            const isPending = pr.status === "PENDING";
                            return (
                                <tr key={pr.id} className={tableRow + ' border-b last:border-0'}>
                                    <td className={tableCell + ' text-center whitespace-nowrap'}>{date}</td>
                                    <td className={tableCell + ' text-center whitespace-nowrap'}>{time}</td>
                                    <td className={tableCell + ' text-center whitespace-nowrap'}>
                                        <span className={`inline-block text-xs font-medium rounded-full px-3 py-1 ${pr.status === "APPROVED" ? "bg-green-100 text-green-600" : pr.status === "REJECTED" ? "bg-red-100 text-red-600" : "bg-yellow-100 text-yellow-800"}`}>{pr.status || "PENDING"}</span>
                                    </td>
                                    <td className={tableCell + ' text-center whitespace-nowrap'}>{pr.branch?.name || pr.branch_name || '-'}</td>
                                    <td className={tableCell + ' text-center'}>
                                        <div className="max-w-[150px] truncate mx-auto" title={pr.remarks || ''}>
                                            {pr.remarks || '-'}
                                        </div>
                                    </td>
                                    <td className={tableCell + ' text-center whitespace-nowrap'}>{pr.user?.username || pr.user?.email || pr.user_id || "-"}</td>
                                    <td className={tableCell + ' text-center'}>
                                        <button
                                            className="text-blue-600 hover:underline font-medium"
                                            onClick={() => onViewDetails(pr)}
                                        >
                                            View Details
                                        </button>
                                    </td>
                                    <td className={tableCell + ' text-center'}>
                                        <div className="flex flex-col md:flex-row items-center justify-center gap-2">
                                            {isPending ? (
                                                <>
                                                    <button
                                                        className="bg-green-500 text-white px-4 py-1 rounded text-xs font-semibold disabled:opacity-50 w-24"
                                                        disabled={actionLoading === pr.id}
                                                        onClick={() => onApprove(pr)}
                                                    >
                                                        {actionLoading === pr.id ? "Approving..." : "Approve"}
                                                    </button>
                                                    <button
                                                        className="bg-red-500 text-white px-4 py-1 rounded text-xs font-semibold disabled:opacity-50 w-24"
                                                        disabled={actionLoading === pr.id}
                                                        onClick={() => onReject(pr)}
                                                    >
                                                        {actionLoading === pr.id ? "Rejecting..." : "Reject"}
                                                    </button>
                                                </>
                                            ) : (
                                                <>
                                                    <button
                                                        className="bg-gray-200 text-gray-400 px-4 py-1 rounded text-xs font-semibold cursor-not-allowed w-24"
                                                        disabled
                                                    >
                                                        Approve
                                                    </button>
                                                    <button
                                                        className="bg-gray-200 text-gray-400 px-4 py-1 rounded text-xs font-semibold cursor-not-allowed w-24"
                                                        disabled
                                                    >
                                                        Reject
                                                    </button>
                                                </>
                                            )}
                                        </div>
                                    </td>
                                </tr>
                            );
                        })
                    )}
                </tbody>
            </table>
        </div>
    );
}
